import { FormControl, FormGroup, Validators } from "@angular/forms";
import { recoverPasswordValidator } from "../../shared/validators/recover-password-validator";

export class ChangePasswordModel {
  password: string;
  confirm: string;
  recoveryKey: string;

  static asFormGroup(model: ChangePasswordModel): FormGroup {
    const fg = new FormGroup({
      password: new FormControl(model.password, [Validators.required]),
      confirm: new FormControl(model.confirm, [Validators.required, recoverPasswordValidator])
    });
    return fg;
  }
}
